import { useEffect } from 'react';
export var UPDATE_CART_ITEMS_COUNT = 'eventbus:UPDATE_CART_ITEMS_COUNT';
export var OPEN_MODAL = 'eventbus:OPEN_MODAL';
var subscribers = [];
export function useSubscribeTo(eventName, callback) {
    useEffect(function () {
        var subscriber = [eventName, callback];
        subscribers.push(subscriber);
        return function () {
            var index = subscribers.findIndex(function (s) { return s === subscriber; });
            if (index >= 0) {
                subscribers.splice(index, 1);
            }
        };
    }, [eventName, callback]);
}
export function dispatch(eventName) {
    return function dispatcher(detail) {
        subscribers
            .filter(function (_a) {
            var e = _a[0];
            return e === eventName;
        })
            .forEach(function (_a) {
            var _ = _a[0], cb = _a[1];
            return cb(detail);
        });
    };
}
